import _get from 'lodash/get';
import { AbstractPlugin } from 'mlb-media-player';
import Bandwagon from 'bandwagon/bandwagon';

/**
 *
 * @module BandwagonAdapter
 * @desc Translates Subject data streams to Bandwagon.dispatches to allow comm for old implementations of
 * the new unified=-player messaging system
 * @class BandwagonAdapter
 *
 */
class BandwagonAdapter extends AbstractPlugin {

    /**
     *
     * @param {object} targetPlayerEvents
     * @param {object} targetPluginEvents
     * @param {object} requestParams
     * @param {string} bandwagonKey
     * @param {MediaPlayer.ObservationCenter} observationCenter
     * @constructor
     *
     */
    constructor(config, observationCenter) {

        super(config, observationCenter);

        /**
         *
         * @type {object}
         *
         */
        this.targetPlayerEvents = _get(config, 'targetPlayerEvents', []);

        /**
         *
         * @type {object}
         *
         */
        this.targetPluginEvents = _get(config, 'targetPluginEvents', []);

        /**
         *
         * @type {ObservationCenter}
         *
         */
        this.observationCenter = observationCenter;

        /**
         *
         * @type {Bandwagon}
         *
         */
        this.dispatcher = Bandwagon.getInstanceByKey(`#${_get(config, 'bandwagonKey', 'video-player')}`);

        this.subscribeToPlayerEvents();

        this.subscribeToPluginEvents();

    }

    /**
     *
     * @desc Subscribe to the player event stream
     * @param {Subject} subject
     *
     */
    subscribeToPlayerEvents(subject) {

        const _this = this;

        this.observationCenter.playerSubject.subscribe((stream) => {

            const type = _this.targetPlayerEvents[stream.type];

            if (type) {

                this.publishMessage(type);

            }

        });

    }

    /**
     *
     * @desc Subscribe to the plugin event stream
     * @param {Subject} subject
     * @todo AdEvents
     *
     */
    subscribeToPluginEvents(subject) {

        const _this = this;

        this.observationCenter.pluginSubject.subscribe((stream) => {

            const type = _this.targetPluginEvents[stream.type];

            if (type) {

                _this.publishMessage(type);

            }

        });

    }

    /**
     *
     *  'META_DATA_LOADED'
     *
     * @desc Publish a message to the bandwagon message bus
     * @param {string} event The event type to publish
     * @param {*} payload object to send
     *
     */
    publishMessage(event, payload) {

        this.dispatcher.publish(event, payload);

    }


}

export default BandwagonAdapter;
